<template>
  <div>
    <p class="mb-3" v-html="$sanitize(payload.content)"></p>
    <a @click="openInternalNotes" class="button is-outlined is-info">Open Internal Notes</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'FeedContentFollowUpCompanies',
  props: {
    payload: {
      type: Object
    }
  },
  methods: {
    openInternalNotes () {
      this.create({
        designator: 'internal-notes-modal',
        component_name: 'InternalNotes',
        resource_type: 'Company',
        resource_id: this.payload.resource_id,
        modal_title: 'הערות פנימיות'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
